/**
 * Função sem efeito que ignora quaisquer argumentos e retorna `undefined`,
 * substituindo o `noop` do lodash por implementação nativa.
 */
export const noop = (..._args: any[]): undefined => undefined
